"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.SHADOW_COLOR="rgba(28, 34, 43, 0.08)",exports.SHADOW_SPREAD=15,exports.SHADOW_THRESHOLD=70;
